import { createKiddoAxios } from "./httpClient";

let settingApiPromise;
const getSettingApi = async () => {
  if (!settingApiPromise) {
    settingApiPromise = createKiddoAxios();
  }
  return settingApiPromise;
};

export const GetAllLanguages = async () => {
  const api = await getSettingApi();
  const response = await api.get("/read/GetAllLanguages");
  return response.data;
};
export const GetProfile = async (id) => {
  const api = await getSettingApi();
  const response = await api.get("/read/GetProfile", {
    params: {
      userId: id,
    },
  });
  return response.data;
};

export const GetDataCountry = async (search = "", page = 1, pageSize = 24) => {
  const api = await getSettingApi();
  const response = await api.get("/read/GetDataCountry", {
    params: { search, page, pageSize },
  });
  return response.data;
};

export const submitAnswer = async (guid, studentId, answers) => {
  try {
    const formData = new FormData();

    formData.append("guid", guid);
    formData.append("studentId", studentId);

    formData.append("ansJson", JSON.stringify(answers.filter(Boolean)));

    console.log(
      "Submitting (FormData):",
      Object.fromEntries(formData.entries())
    );

    const api = await getSettingApi();
    const response = await api.post("/insert/SubmitAnswer", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (err) {
    console.error("Gagal submit jawaban:", err);
    return err;
  }
};
